import React from 'react';
import { Column, Columns } from '../../styled/Columns/wrappers';
import { Link } from '../../styled/Link';
import Text from '../../styled/Text';

interface IStorePanelStatus {
  store: IPanelStore;
}

const PanelStoreInfo = ({ store }: IStorePanelStatus) => {
  return (
    <>
      <Columns className="space-half valign-middle">
        <Column>Öppet idag:</Column>
        <Column>
          <Text tone="alt">{` ${store.openToday}`}</Text>
        </Column>
      </Columns>
      <Link href={`/butiker/${store?.slug}`} className="subtle underline">
        Butiksinformation
      </Link>
    </>
  );
};

export default PanelStoreInfo;
